<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.language') }}
      </div>
    </div>
    <div class="wrap_box">
      <div
        class="item"
        :class="{ 'is-selected': lang === 'ko_kr' }"
        @click="changeLang('ko_kr')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ko_kr.png"></div>
          <div class="info">
            한국어
          </div>
        </div>
        <div v-if="lang=='ko_kr'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'zh_hk' }"
        @click="changeLang('zh_hk')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_hk.png"></div>
          <div class="info">
            Türkçe
          </div>
        </div>
        <div v-if="lang=='zh_hk'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'en_us' }"
        @click="changeLang('en_us')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/en_us.png"></div>
          <div class="info">
            English
          </div>
        </div>
        <div v-if="lang=='en_us'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'id_ind' }"
        @click="changeLang('id_ind')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/id_ind.png"></div>
          <div class="info">
            Indonesia
          </div>
        </div>
        <div v-if="lang=='id_ind'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'th_th' }"
        @click="changeLang('th_th')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/th_th.png"></div>
          <div class="info">
            Italiano
          </div>
        </div>
        <div v-if="lang=='th_th'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'vi_vn' }"
        @click="changeLang('vi_vn')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/vi_vn.png"></div>
          <div class="info">
            Español
          </div>
        </div>
        <div v-if="lang=='vi_vn'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'ja_jp' }"
        @click="changeLang('ja_jp')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ja_jp.png"></div>
          <div class="info">
            日本語
          </div>
        </div>
        <div v-if="lang=='ja_jp'">
          ✓
        </div>
      </div>
			
      <div
        class="item"
        :class="{ 'is-selected': lang === 'ms_my' }"
        @click="changeLang('ms_my')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ms_my.png"></div>
          <div class="info">
            Melayu
          </div>
        </div>
        <div v-if="lang=='ms_my'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'pt_br' }"
        @click="changeLang('pt_br')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/pt_br.png"></div>
          <div class="info">
            Brasil
          </div>
        </div>
        <div v-if="lang=='pt_br'">
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'zh_cn' }"
        @click="changeLang('zh_cn')"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_hk2.png"></div>
          <div class="info">
            繁體中文
          </div>
        </div>
        <div v-if="lang=='zh_cn'">
          ✓
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		name: "Language",
		data() {
			return {
				lang:this.$i18n.locale||"en_us",
			};
		},
		created() {
		},
		mounted() {
		},
		methods: {
			changeLang(lang) {
				Toast.loading({
					// mask: true,
					duration: 200
				})
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	
	.wrap_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 0 0 5px 5px;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ECECEC;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			.right{
				width: 20px;
				height: 20px;
				background: url(../images/user/arrow.png) no-repeat center center;
				background-size: 100% 100%;
			}
			.right_info{
				color: rgba(0,0,0,.6);
			}
			.tips{
				color: rgba(0,0,0,.6);
				margin-left: auto;
				margin-right: 4px;
				font-weight: normal;
			}
			.left{
				img{
					width: 33px;
					margin-top: 5px;
				}
			}
		}
	}

	/* Match the account-centre palette while retaining the existing language flow. */
	.basic_wrap {
		min-height: 100vh;
		padding-bottom: 1.2rem;
		box-sizing: border-box;
		background: url('../images/shop2/2.png') no-repeat top;
	}

	.red_top_bg {
		height: 50px;
		border-bottom: 1px solid rgba(235, 235, 235, .82);
		background: rgba(255, 255, 255, .86);
		color: #222;
		backdrop-filter: blur(10px);
	}

	.big_tit {
		top: 13px;
		color: #222;
		font-size: 16px;
		font-weight: 700;
	}

	.wrap_box {
		width: calc(100% - 24px);
		margin: 14px auto 0;
		padding: 4px 16px;
		border: 1px solid #ebebeb;
		border-radius: 18px;
		background: rgba(255, 255, 255, .95);
		box-sizing: border-box;
		box-shadow: none;
	}

	.wrap_box .item {
		width: 100%;
		height: 62px;
		padding: 0;
		border-bottom-color: #f0f0f0;
		color: #3b3b3b;
		font-size: 14px;
		font-weight: 500;
		line-height: 62px;
	}

	.wrap_box .item .left img {
		width: 30px;
		margin: 0 12px 0 0;
		vertical-align: middle;
	}

	.wrap_box .item > div:last-child {
		color: #ff385c;
		font-size: 20px;
		font-weight: 700;
	}



	.red_top_bg {
		height: 50px;
		background: rgba(255, 255, 255, .9);
		box-shadow: 0 1px 0 rgba(35, 44, 57, .07);
	}

	.big_tit {
		top: 0;
		height: 50px;
		font-size: 15px;
		line-height: 50px;
	}

	.back_left {
		position: relative;
		width: 44px;
		height: 50px;
		margin: 0;
		background: none;
	}

	.back_left::after {
		position: absolute;
		top: 18px;
		left: 17px;
		width: 11px;
		height: 11px;
		border-bottom: 2px solid #484848;
		border-left: 2px solid #484848;
		content: '';
		transform: rotate(45deg);
	}

	.wrap_box {
		margin-top: 18px;
		padding: 3px 14px;
		border-color: rgba(255, 255, 255, .95);
		border-radius: 20px;
		background: rgba(255, 255, 255, .96);
		box-shadow: 0 12px 28px rgba(37, 47, 63, .08);
	}

	.wrap_box .item {
		box-sizing: border-box;
		display: flex;
		height: 56px;
		min-height: 56px;
		align-items: center;
		padding: 0 8px;
		color: #343a44;
		font-size: 15px;
		font-weight: 500;
		line-height: 56px;
		transition: background-color .2s ease;
	}

	.wrap_box .item .left img {
		width: 27px;
		margin-right: 13px;
	}

	.wrap_box .item .info {
		color: #343a44;
		font-size: 15px;
		font-weight: 500;
	}

	.wrap_box .item.is-selected {
		margin: 4px 0;
		padding: 0 8px;
		border-bottom: 0;
		border-radius: 13px;
		background: #fff3f6;
	}

	.wrap_box .item.is-selected .info {
		color: #d81f62;
		font-weight: 700;
	}

	.wrap_box .item.is-selected > div:last-child {
		display: flex;
		width: 22px;
		height: 22px;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: #ff385c;
		color: #fff;
		font-size: 13px;
		line-height: 1;
	}
</style>
